import React from 'react';
import AdminNavbar from '../AdminComponents/AdminNavbar/AdminNavbar';
import useIdleLogout from '../hooks/useIdleLogout';

const AdminLayout = () => {
  useIdleLogout();

  return (
    <div className="admin-main-wrapper">
      <AdminNavbar />
    </div>
  );
};

export default AdminLayout;